<script setup lang="ts">
import { getUsers } from '~~/src/api/users'
import UsersList from '~~/src/components/User/List/index.vue'
import type { UserProfile } from '~~/src/types/user'
const props = defineProps<{
  search: string
}>()

const search = toRef(props, 'search')

const { data, pending, refresh } = useAPI(async () => {
  if (search.value.trim() === '')
    return []
  const data = await getUsers({
    search: search.value,
    size: 10,
  })
  return data
}, {
  watch: [search],
  immediate: false,
})

watch(search, () => refresh())
const filteredUsers = computed(() => {
  return (search.value && data.value && data.value[0])
    ? data.value.map(u => ({
      ...u,
      created_at: u.createdAt, // default value if not exists
    } as UserProfile))
    : [] as UserProfile[]
})
</script>

<template>
  <AppTab name="Users" :count="filteredUsers.length" overflow-auto>
    <UsersList :is-loading="pending" :users="filteredUsers" :is-searching="!!search" />
  </AppTab>
</template>
